module.exports = __webpack_public_path__ + "static/media/404.7800d5bc.svg";